import React from 'react'
import img2054 from '../components/images/dsem.jpg'
import img2054a from '../components/images/semkeyword.jpg'
import img2054b from '../components/images/semad.jpg'
import img2054c from '../components/images/sembid.jpg'



const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2054} alt='Sem' />
            </div>
            <div className='container text-center'>
                <h2>The Power of SEM: Maximize Your Marketing</h2>
                <p>
                    <b> SEM (Search Engine Marketing)  </b>is a digital marketing strategy focused on increasing visibility in search engine results pages (SERPs) through paid advertising. It involves leveraging paid search ads, such as Google Ads or Bing Ads, to target specific keywords and audiences, driving website traffic and conversions.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Keyword Targeting: 🎯</b><br />
                            Identifying and bidding on relevant keywords that potential customers are searching for to ensure ads appear in relevant search results. This involves continuous keyword research and refinement to align with changing search trends.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2054a} alt='Queryimg' />
                    </div>
                </div>

                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Ad Copy Creation: ✍️</b><br />
                            Crafting compelling ad copy that attracts clicks and drives traffic to the website, incorporating persuasive language and clear calls-to-action. Tailoring ad messaging to match user intent improves ad relevance and performance.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2054b} alt='Queryimg' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Bid Management: 💰</b><br />
                            Managing bids to optimize ad spend and maximize return on investment (ROI) by adjusting bids based on performance metrics like click-through rates and conversion rates. Implementing bid strategies such as automated bidding or bid adjustments helps achieve campaign goals efficiently.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2054c} alt='Queryimg' />
                    </div>
                </div >

            </div>
        </>
    )
}

export default events